import { inject, Injectable } from '@angular/core';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption, SkeletonLoaderLayout } from 'gung-list';
import { Observable } from 'rxjs';
import { CompanyTemplatesListViewComponent } from '../components/company-templates-list-view/company-templates-list-view.component';
import { CompanyTemplate } from '../models/company-template';
import { CompanyTemplatesService } from './company-templates.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyTemplatesListConfigService implements ConfigService<CompanyTemplate> {
  protected companyTemplatesService = inject(CompanyTemplatesService);

  skeletonLoaderLayout: SkeletonLoaderLayout = 'table';

  getLayouts(): ListLayout<CompanyTemplate>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CompanyTemplatesListViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'CompanyTemplatesTable'
      }
    ];
  }

  getItems(): Observable<CompanyTemplate[]> {
    return this.companyTemplatesService.getAllCompanyTemplates();
  }

  getFilters(): ConfigBaseFilter<CompanyTemplate>[] {
    return [];
  }

  getSortOptions(): ListSortOption<CompanyTemplate>[] {
    return [];
  }

  getBatchSizes(): number[] {
    return [24];
  }

  getSearchTerms(item: CompanyTemplate): string[] {
    return [item.id];
  }

  getItemId(item: CompanyTemplate): string {
    return item.id;
  }
}
